import React, { Fragment } from "react";
import FormLabel from "@material-ui/core/FormLabel";
import Switch from "@material-ui/core/Switch";
import { fieldExistsOnPlayType } from "games/utils";

const PlayCheckboxInput = ({
  inputName,
  label,
  handleInputChange,
  play,
  classes,
  overrideFieldExists = null
}) => {
  const fieldExistsCheck = overrideFieldExists || inputName;
  return (
    <Fragment>
      {fieldExistsOnPlayType(play.playType, fieldExistsCheck) && (
        <div className={classes.input}>
          <FormLabel>{label}</FormLabel>
          <Switch
            checked={play[inputName] || false}
            onChange={(event) => handleInputChange(event, inputName)}
            id={inputName}
          />
        </div>
      )}
    </Fragment>
  );
};

export default PlayCheckboxInput;
